import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';

const Index = (props) => {
  let {
    match: { path },
  } = props;

  return (
    <Switch>
      <Route path={path} exact={true} component={lazy(() => import('./NationalPlanList'))} />
      <Route
        path={`${path}/consolidated-plan-details/:documentId`}
        exact={true}
        component={lazy(() => import('./ConsolidatedPlanDetails'))}
      />
      <Route
        path={`${path}/:documentName/:documentId`}
        exact={true}
        component={lazy(() => import('./NationalPlanDetails'))}
      />
      <Route
        path={`${path}/:documentName/:documentId/:commentName/:commentId`}
        exact={true}
        component={lazy(() => import('./CommentDetails'))}
      />
      <Route
        path={`${path}/upload-consolidated-plan`}
        exact={true}
        component={lazy(() => import('./UploadConsolidatedNationalPlan'))}
      />
      <Route
        path={`${path}/pending-national-plan`}
        exact={true}
        component={lazy(() => import('./PendingNationalPlanList'))}
      />
    </Switch>
  );
};

export default React.memo(Index);
